// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2zElJ","unreadBadge":"styles_unreadBadge__17VGI","modalContent":"styles_modalContent__3E_tf","modal":"styles_modal__1Sviu"};